<template>
  <div class="be-wrapper be-login" v-if="showError">
    <div class="be-content">
      <div class="main-content container-fluid">
        <div class="splash-container">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-body">
              <span class="splash-title xs-pb-20"><h3>Ошибка!</h3></span>
              <h4>Неверный код подтверждения email!</h4>
            </div>
            <div class="splash-footer">
                <span>Вернуться на страницу <router-link :to="{name:'login'}">авторизации</router-link></span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        showError: false,
      }
    },
    mounted () {
      axios.post('/api/rest-auth/registration/verify-email/', {key: this.$route.query.key}).then((response) => {
        this.$snotify.success('Ваш Email адрес успешно подтвержден. Используйте email/пароль для входа в систему.', 'Успешно!')
        this.$router.push({name: 'login'})
      }).catch((error) => {
        this.showError = true
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/VerifyEmail.vue